import { IS_SSR } from '../../constants';
import { getOneTrustActiveGroups, type OneTrustGroups } from './getOneTrustActiveGroups';

/**
 * OneTrust officially recommends `OneTrustGroupsUpdated` for consent-dependent logic.
 * It fires when the CMP script loads and when the user updates consent preferences.
 * OneTrust also documents that this listener can be registered before the SDK loads,
 * which is required for early callers like Next.js `instrumentation-client.js`.
 *
 * Docs: https://developer.onetrust.com/onetrust/docs/javascript-events-guide
 */
export function onOneTrustGroupsUpdated(callback: (groups: OneTrustGroups) => void): () => void {
    if (IS_SSR) {
        return () => undefined;
    }

    const handler = (event: WindowEventMap['OneTrustGroupsUpdated']) => {
        callback(getOneTrustActiveGroups(event));
    };

    window.addEventListener('OneTrustGroupsUpdated', handler);

    return () => {
        window.removeEventListener('OneTrustGroupsUpdated', handler);
    };
}
